<template>
  <div id="RadioParsing">
    <div class="topic_title">{{bankdata.order}}.( {{typetext}} ){{bankdata.questionTitle}}</div>
    <div class="topic_box">
      <p :key="index" class="option" v-for="(item, index) in listData.questionSelect">
        <el-radio :label="item.value" disabled v-model="radio">{{item.lable}}</el-radio>
      </p>
    </div>
    <div class="el-Parsing">
      <div class="title">
        <div class="title_item">
          参考答案：
          <span class="blue">{{bankdata.questionAnswer}}</span>
        </div>
        <div class="title_item">
          你的答案：
          <span class="red">{{bankdata.select}}</span>
        </div>
      </div>
      <div class="content" v-if="bankdata.questionDescribe">答案解析：{{bankdata.questionDescribe}}</div>
      <div class="content" v-else>答案解析：解析正在更新中...</div>
    </div>
  </div>
</template>
<script>
module.exports = {
  name: 'radio-parsing',
  props: ['bankdata', 'typetext'],
  data () {
    return {
      radio: '',
      listData: '',
      img_url: ''
    }
  },
  mounted () {
    console.log('sadfasfasdfads')
    if (this.bankdata) {
      this.initFn()
    } else {
      console.log(7788877)
    }
  },
  watch: {
    bankdata () {
      this.radio = ''
      this.initFn()
    }
  },
  computed: {},
  methods: {
    initFn: function () {
      console.log(this.bankdata, 1)
      let arr = this.bankdata.questionSelect
      if (this.bankdata.img) {
        this.img_url = sessionStorage.getItem('base_url') + this.bankdata.img
      } else {
        this.img_url = ''
      }
      if (!(arr instanceof Array)) {
        arr = arr.split('###')
        let obj = []
        for (let i = 0; i < arr.length; i++) {
          obj[i] = {}
          obj[i].lable = arr[i]
          obj[i].value = arr[i].substring(0, 1)
        }
        this.bankdata.questionSelect = obj
      }
      this.listData = this.bankdata
      this.radio= this.listData.select
    }
  }
}
</script>
<style scoped>
.title {
  display: flex;
  font-size: 1rem;
}
.title_item {
  display: inline-flex;
  align-items: center;
}
.content {
  color: #222;
  font-size: 0.875rem;
  line-height: 1.375rem;
  margin: 1.25rem 0;
}
</style>
